<template>
  <div class="god_page_container">
    <h2>Reservas</h2>
    <div id="selector_container">
      <input
        type="date"
        v-model="rangoFechas.start"
        class="input_200"/>

      <input
        type="date"
        v-model="rangoFechas.end"
        class="input_200"/>

      <div class="radio-group">
        <label>
          <input
            type="radio"
            value="0"
            v-model="modo"
            :disabled="!rangoFechas || rangoFechas.start === null || rangoFechas.end === null"
          />
          Día del plan
        </label>
        <label>
          <input
            type="radio"
            value="1"
            v-model="modo"
            :disabled="!rangoFechas || rangoFechas.start === null || rangoFechas.end === null"
          />
          Día de la reserva
        </label>
      </div>
      <input
        type="email"
        class="input_200"
        v-model="user_email"
        placeholder="Email del usuario"
      />

      <input
        type="text"
        class="input_200"
        v-model="planId"
        placeholder="ID del plan"
      />

      <input
        type="text"
        class="input_200"
        v-model="title"
        placeholder="Título del plan"
      />

      <input
        type="text"
        class="input_200"
        v-model="bookingCode"
        placeholder="Código de reserva"
      />

      <input
        type="text"
        class="input_200"
        v-model="companyId"
        placeholder="ID de la empresa"
      />

      <select 
        v-model="ciudad"
        class="input_200"
        :style="{ color: ciudad === '' ? 'var(--text-color-placeholder)' : '' }">
        <option value="">Ciudad</option>
        <option value="Donosti">Donosti</option>
        <option value="Logroño">Logroño</option>
        <option value="Pamplona">Pamplona</option>
        <option value="Pirineo Aragones">Pirineo Aragonés</option>
        <option value="Valencia">Valencia</option>
        <option value="Zaragoza">Zaragoza</option>
      </select>

      <button @click="applyFilter()" class="input_200 main_button">Buscar</button>
    </div>
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="small">Ciudad</th>
            <th class="very_small">Id del Plan</th>
            <th class="very_small">Codigo</th>
            <th class="big">Nombre de la empresa</th>
            <th class="big">Título</th>
            <th class="very_small">Fecha</th>
            <th class="very_small">Hora</th>
            <th class="small">Usuario</th>
            <th class="very_small">Cantidad</th>
            <th class="very_small">Total pagado</th>
          </tr>
        </thead>
        <tfoot v-if="reservations.length > 0">
          <tr class="font-bold bg-gray-200">
            <td><b>Totales:</b></td>
            <td colspan="7"></td>
            <td><b>{{ totalReservas }}</b></td>
            <td><b>{{ totalPagado }}€</b></td>
          </tr>
        </tfoot>
        <tbody>
          <tr 
            v-for="(item, index) in reservations"
            :key="item.id"
            :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
            @click="purchaseClicked(item.codigo, true)"
          >
            <td>{{ item.ciudad }}</td>
            <td>{{ item.id_promo }}</td>
            <td>
              <div v-for="(codigo, index) in splitCodigo(item.codigo)" :key="index">
                {{ codigo }}
              </div>
            </td>
            <td>{{ item.nombre_empresa }}</td>
            <td>{{ item.titulo }}</td>
            <td>{{ item.fecha ? item.fecha : '--' }}</td>
            <td>{{ item.hora ? item.hora : '--' }}</td>
            <td>{{ item.user_email }}</td>
            <td>{{ item.cantidad_pedida }}</td>
            <td>{{ item.pagado ? (item.pagado + '€') : '--' }}</td>
          </tr>
      
        </tbody>
      </table>
    </div>
    <div v-if="reservations.length === 0" style="display: flex; justify-content: center; margin-top: 1rem;">
      <label>No hay ninguna reserva para la fecha seleccionada</label>
    </div>
    <div v-if="reservations.length !== 0" style="display: flex; justify-content: center; margin-top: 1rem;">
      <button @click="exportXLS()" class="main_button">Exportar</button>
    </div>


    <PurchaseDetailsPopup 
      :purchaseData="selectedPurchaseData"
      @userProductsChanged="userProductsChanged($event)"
      />

    <ErrorPopup :errorMessage="error" />

  </div>

</template>

<script setup>
  import { computed, ref, nextTick, onMounted, watch } from 'vue'
  import { useLoadingStore } from "@/stores/loadingStore";
  import { refreshToken } from "@/services/authService";
  import { useRoute, useRouter } from 'vue-router';
  import PurchaseDetailsPopup from './PurchaseDetailsPopup.vue';
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  import ErrorPopup from "@/components/common/ErrorPopup.vue";

  const route = useRoute();

  const ciudad = ref(route.query.ciudad || '');
  const rangoFechas = ref({
    start: route.query.startDate || null,
    end: route.query.endDate || null
  });
  const modo = ref(route.query.modo ? parseInt(route.query.modo) : 0);
  const title = ref(route.query.title || '');
  const bookingCode = ref(route.query.bookingCode || '');
  const user_email = ref(route.query.user_email || '');
  const planId = ref(route.query.planId || '');
  const companyId = ref(route.query.companyId || '');
  const selectedPurchaseData = ref(null);

  const error = ref(null);
  const reservations = ref([]);
  const loadingStore = useLoadingStore();
  const router = useRouter();

  watch([ciudad, rangoFechas, modo, title, bookingCode, user_email, planId, companyId], () => {
    router.replace({
      query: {
        ...route.query,
        ciudad: ciudad.value,
        startDate: rangoFechas.value.start,
        endDate: rangoFechas.value.end,
        modo: modo.value,
        title: title.value,
        bookingCode: bookingCode.value,
        user_email: user_email.value,
        planId: planId.value,
        companyId: companyId.value
      }
    });
  }, { deep: true });

  const totalReservas = computed(() =>
    reservations.value.reduce((sum, item) => sum + Number(item.cantidad_pedida || 0), 0)
  )

  const totalPagado = computed(() =>
    reservations.value.reduce((sum, item) => sum + Number(item.pagado || 0), 0).toFixed(2)
  )

  const exportXLS = () => {
    const flatData = [];

    reservations.value.forEach(reserva => {
        const preguntasTexto = (reserva.campos || [])
          .map(campo => `${campo.pregunta}: ${campo.respuesta}`)
          .join(' /// ');
      
        let entry = {
          "Ciudad": reserva.ciudad,
          "ID_Plan": reserva.id_promo,
          "Codigo": reserva.codigo,
          "Título": reserva.titulo,
          "Fecha": reserva.fecha || '--',
          "Hora": reserva.hora || '--',
          "Usuario": reserva.user_email,
          "Cantidad": reserva.cantidad_pedida,
          "Total pagado": reserva.pagado ? `${reserva.pagado}€` : '--',
          "Preguntas": preguntasTexto || '--',
        };

        flatData.push(entry);
    });

      // Crear la hoja de Excel
    const worksheet = XLSX.utils.json_to_sheet(flatData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reservas");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(data, "god.xlsx");
  }

  const applyFilter = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await callAPIToGetReservations();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await callAPIToGetReservations();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error obteniendo las reservas.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        showError(data.message);
        reservations.value = [];
      } else {
        reservations.value = data.reservations;
      }
    } catch (exception) {
      showError(exception.message);
    } finally {
      loadingStore.setLoading(false);
    }
  }

  async function callAPIToGetReservations() {
    let dateMinStr = ""
    if (rangoFechas.value != null && rangoFechas.value.start != null){
      dateMinStr = formatearParaAPI(rangoFechas.value.start);
    }
    let dateMaxStr = ""
    if (rangoFechas.value != null && rangoFechas.value.end != null){
      dateMaxStr = formatearParaAPI(rangoFechas.value.end);
    }
    return await fetch(process.env.VUE_APP_API_URL+"api/god/reservations/get?user_id="+localStorage.getItem('user_id')
      +"&type="+modo.value
      +"&date_min="+dateMinStr
      +"&date_max="+dateMaxStr
      +"&city="+ciudad.value
      +"&promo_title="+title.value
      +"&purchase_code="+bookingCode.value
      +"&plan_id="+planId.value
      +"&company_id="+companyId.value
      +"&user_email="+user_email.value,
       {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

  const showError = async (message) => {
    error.value = null;
    await nextTick(); // Espera a que Vue reaccione al cambio
    error.value = message;
  };

    function formatearParaAPI(dateStr) {
    const [year, month, day] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  }

  const purchaseClicked = async (purchaseCode, showErrors) => {
    loadingStore.isLoading = true;
    error.value = null;
    selectedPurchaseData.value = null;

    try {
      let response = await fetchPurchaseInfo(purchaseCode);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await fetchPurchaseInfo(purchaseCode);
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        if (showErrors) {
          showError("Se ha producido un error obteniendo la información de la reserva.");
        }
        return;
      }

      const data = await response.json();

      if (data.errors) {
        if (showErrors) {
          showError(data.message);
        }
      } else {
        error.value = null;
        selectedPurchaseData.value = data.datos;
        history.pushState({ popupOpen: true }, "");
      }
    } catch (exception) {
      if (showErrors) {
        showError(exception.message);
      }
      selectedPurchaseData.value = null;
    } finally {
      loadingStore.setLoading(false);
    }
  };

  async function fetchPurchaseInfo(purchaseCode) {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/reservations/get_purchase_code_info", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "purchase_code": purchaseCode
      }),
    });
  }

  function splitCodigo(codigo) {
    return codigo?.includes(';') ? codigo.split(';') : [codigo];
  }

  const userProductsChanged = (purchaseCode) => {
    applyFilter();
    purchaseClicked(purchaseCode, false);
  };

  onMounted(() => {
    if (planId.value !== "" || user_email.value !== "" || rangoFechas.value.start != null || rangoFechas.value.end != null) {
      applyFilter();
    }
  });


</script>

<style scoped>

#selector_container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 1rem;
  justify-content: space-between;
}

@media (max-width: 768px) {
  #selector_container > * {
    flex: none !important;
  }

  .input_200, .radio-group {
    width: 100%;
  }

  table {
    width: 100%;
    min-width: 0px;
  }
}


.input_200 {
  box-sizing: border-box;
  min-width: 200px;
  flex: 1 1 200px;
  padding: 8px;
  width: 100%;
  line-height: 1.2;
  height: 50px;
  max-height: 50px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1 1 200px;
}

.button {
  margin-left: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1 1 200px;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 30px;
  min-width: 800px; /* evita que se aplaste */
}

th {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: var(--gray);
  color: white;
  border: 0px;
}

tfoot {
  background-color: var(--gray);
  color: white;
  border: 0px;
}
.big {
  width: 15%;
}

.small {
  width: 8%;
}

.very_small {
  width: 6%;
}

tr{
  cursor: pointer;
}

td {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
}

.bg-gray-100 {
  background-color: var(--almost-white);
}

.bg-white {
  background-color: white;
}

.action_icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 0px 5px;
}

</style>
